import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { Row, Col } from 'react-bootstrap'
import { CustomDataTable } from '../components/CustomDataTable';
import { LoadingBox } from '../components/LoadingBox';
import { ToolBar } from '../components/ToolBar'
import Swal from 'sweetalert2';
import { getNotificationsUser } from '../actions/notificationActions';
import { getStopbullyings, getStopbullyingsUser, createStopbullying, readStopbullying, responseStopbullying } from '../actions/stopbullyingActions';
import removeAccents from '../utils/removeAccents';
import { changeMenu } from '../actions/navigationActions';

export const StopbullyingScreen = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const stopbullyings = useSelector((state) => state.stopbullyingList)

    const { userInfo } = useSelector(state => state.userSignin)
    const [inbox, setInbox] = useState(true)
    const [stopbullyingsIn, setStopbullyingsIn] = useState([])
    const [stopbullyingsOut, setStopbullyingsOut] = useState([])

    const [sendingStopbullying, setsendingStopbullying] = useState(false)
    const stopbullying1 = useRef(null);
    const modalCancelButton = useRef(null)
    const [lastestStopbullyings, setLastestStopbullyings] = useState('')
    const [lastestStopbullyingMedia, setLastestStopbullyingMedia] = useState([])
    const [stopbullyingsResume, setStopbullyingsResume] = useState(null)
    const [stopbullyingsShow, setStopbullyingsShow] = useState(null)

    const [stopbullying, setStopbullying] = useState('')
    const [fileList, setFileList] = useState(null)
    const files = fileList ? [...fileList] : []

    const [newStopbullying, setNewStopbullying] = useState('')
    const [subjectStopbullying, setSubjectStopbullying] = useState('')
    const [newfileList, setNewFileList] = useState(null)
    const newfiles = newfileList ? [...newfileList] : []

    const pushStopbullyingHandler = async(e) => {
        e.preventDefault();

        if (stopbullying !== '') {
            setsendingStopbullying(true)
            if(stopbullyingsShow.sender._id === userInfo._id){
                dispatch(responseStopbullying({
                    idstopbullying: stopbullyingsShow.parent,
                    sender: userInfo._id,
                    receiver: stopbullyingsShow.sender._id,
                    message: stopbullying,
                    media: files
                }))
            }else{
                dispatch(responseStopbullying({
                    idstopbullying: stopbullyingsShow.parent,
                    sender: userInfo._id,
                    receiver: stopbullyingsShow.receiver._id,
                    message: stopbullying,
                    media: files
                }))
            }
            setsendingStopbullying(false)
            Swal.fire({
                position: 'center',
                iconHtml: '<img src="/success.svg" class="mt-5">',
                html: '<p class="mb-7 mt-10 fw-bolder fs-2">Mensaje enviado</p><p class="mb-5">Hemos enviado el mensaje a sus destinatarios de forma correcta.</p><p class="fw-bolder">¿Qué quieres hacer ahora?</p>',
                showConfirmButton: true,
                showDenyButton: true,
                denyButtonText: `<button type="button" class="btn btn-info-outline text-info rounded-pill mt-0"><img src="/store.svg" alt="Tienda" class="me-2">Ir a tienda</button>`,
                denyButtonColor: "white",
                confirmButtonText: `<button type="button" class="btn btn-light-red-outline text-light-red rounded-pill mt-0"><img src="/school.svg" alt="Tienda" class="me-2">Ir a colegio</button>`,
                confirmButtonColor: "white",
                customClass: "invisible-buttons"
            }).then(result => {
                if (result.isConfirmed) {
                    dispatch(changeMenu("school"))
                    navigate('/')
                }
                if (result.isDenied) {
                    dispatch(changeMenu("store"))
                    navigate('/')
                }
            })
        }
        setStopbullying('')
    }

    const createStopbullyingHandler = async() => {
        if (newStopbullying !== '') {
            setsendingStopbullying(true)
            dispatch(createStopbullying({
                sender: userInfo._id,
                subject: subjectStopbullying,
                message: newStopbullying,
                media: newfiles
            }))
            setsendingStopbullying(false)
            Swal.fire({
                position: 'center',
                iconHtml: '<img src="/success.svg" class="mt-5">',
                html: '<p class="mb-7 mt-10 fw-bolder fs-2">Mensaje enviado</p><p class="mb-5">Hemos enviado el mensaje a sus destinatarios de forma correcta.</p><p class="fw-bolder">¿Qué quieres hacer ahora?</p>',
                showConfirmButton: true,
                showDenyButton: true,
                denyButtonText: `<button type="button" class="btn btn-info-outline text-info rounded-pill mt-0"><img src="/store.svg" alt="Tienda" class="me-2">Ir a tienda</button>`,
                denyButtonColor: "white",
                confirmButtonText: `<button type="button" class="btn btn-light-red-outline text-light-red rounded-pill mt-0"><img src="/school.svg" alt="Tienda" class="me-2">Ir a colegio</button>`,
                confirmButtonColor: "white",
                customClass: "invisible-buttons"
            }).then(result => {
                if (result.isConfirmed) {
                    dispatch(changeMenu("school"))
                    navigate('/')
                }
                if (result.isDenied) {
                    dispatch(changeMenu("store"))
                    navigate('/')
                }
            })
        }
        closeModal()
        dispatch(getStopbullyingsUser(userInfo._id))
    }

    useEffect(() => {
        dispatch(getStopbullyingsUser(userInfo._id))
        dispatch(getNotificationsUser())
    }, [dispatch, navigate])

    useEffect(() => {
        if(stopbullyings){
            let arrayStopbullyingsIn = []
            let arrayStopbullyingsOut = []

            stopbullyings.stopbullyingsIn?.map((stopbullyings) => {
                arrayStopbullyingsIn.push(stopbullyings)
            })
            setStopbullyingsIn(arrayStopbullyingsIn)

            stopbullyings.stopbullyingsOut?.map((stopbullyings) => {
                arrayStopbullyingsOut.push(stopbullyings)
            })
            setStopbullyingsOut(arrayStopbullyingsOut)
        }
    }, [stopbullyings])

    useEffect(() => {
        if(stopbullyingsResume){
            let stopbullyingsStructure = ""
            if(stopbullyingsResume.type === 'inbox'){
                let stopbullyingToShow = stopbullyingsIn.find(stopbullyingIn => stopbullyingIn._id === stopbullyingsResume._id)
                if(stopbullyingToShow?._id !== stopbullyingsShow?._id){
                    setStopbullyingsShow(stopbullyingToShow)
                    dispatch(readStopbullying(stopbullyingsResume._id))

                    let timeToSave = 0

                    if(stopbullyingToShow?.stopbullyings){
                        for (let stopbullyingNow of stopbullyingToShow?.stopbullyings) {
                            if(stopbullyingNow._id === stopbullyingsResume._id){
                                timeToSave = 1
                            }
                            if(timeToSave === 1){
                                stopbullyingsStructure += '<hr class="mt-3 mb-10" style="border-style: dashed"/>'+
                                "<div>" + stopbullyingNow.message + "</div>";
                                if(stopbullyingNow.media?.length > 0){
                                    stopbullyingNow.media?.map((imagen) => {
                                        stopbullyingsStructure += '<div><a href="'+imagen+'" target="_blank"><img class="w-100 my-2" src="'+imagen+'"/></a></div>'
                                    })
                                }

                                stopbullyingsStructure += '<p>'+new Date(stopbullyingNow.date)?.toTimeString().substring(0, 5)+'    '+stopbullyingNow.date?.substr(8,2)+'/'+stopbullyingNow.date?.substr(5,2)+'/'+stopbullyingNow.date?.substr(0,4)+'</p>'
                            }
                        }
                    }
                    setLastestStopbullyings(stopbullyingsStructure)

                }else{
                    setStopbullyingsShow(null)
                    setLastestStopbullyings('')
                    setLastestStopbullyingMedia([])
                }
            }else{
                let stopbullyingToShow = stopbullyingsOut.find(stopbullyingOut => stopbullyingOut._id === stopbullyingsResume._id)
                if(stopbullyingToShow !== stopbullyingsShow){
                    setStopbullyingsShow(stopbullyingToShow)

                    let timeToSave = 0

                    if(stopbullyingToShow?.stopbullyings){
                        for (let stopbullyingNow of stopbullyingToShow?.stopbullyings) {
                            if(stopbullyingNow._id === stopbullyingsResume._id){
                                timeToSave = 1
                            }
                            if(timeToSave === 1){
                                stopbullyingsStructure += '<hr class="mt-3 mb-10" style="border-style: dashed"/>'+
                                "<div>" + stopbullyingNow.message + "</div>";
                                if(stopbullyingNow.media?.length > 0){
                                    stopbullyingNow.media?.map((imagen) => {
                                        stopbullyingsStructure += '<div><a href="'+imagen+'" target="_blank"><img class="w-100 my-2" src="'+imagen+'"/></a></div>'
                                    })
                                }

                                stopbullyingsStructure += '<p>'+new Date(stopbullyingNow.date)?.toTimeString().substring(0, 5)+'    '+stopbullyingNow.date?.substr(8,2)+'/'+stopbullyingNow.date?.substr(5,2)+'/'+stopbullyingNow.date?.substr(0,4)+'</p>'
                            }
                        }
                    }
                    setLastestStopbullyings(stopbullyingsStructure)
                }else{
                    setStopbullyingsShow(null)
                    setLastestStopbullyings('')
                    setLastestStopbullyingMedia([])
                }
            }
        }
    }, [stopbullyingsResume])
  
    const handleFileChange = (e) => {
        setFileList(e.target.files)
    }
  
    const handleNewFileChange = (e) => {
        setNewFileList(e.target.files)
    }

    const closeModal = () => {
        setNewStopbullying('')
        setSubjectStopbullying('')
        setNewFileList(null)
        modalCancelButton.current.click()
    }

    useEffect(() => {
        setStopbullyingsShow(null)
    }, [inbox])

    const columnsIn = [
        {
            name: "Asunto",
            cell: row => 
                <div className="d-flex align-items-center" onClick={() => setStopbullyingsResume({type: 'inbox', _id: row._id})}>
                    {inbox === true && row.receiver_read === false
                        ? <h2>{row.subject}</h2>
                        : row.subject
                    }
                </div>,
            selector: (row) => removeAccents(row.subject),
            sortable: true,
        },
        {
            name: 'Fecha',
            cell: row =>
                <div className="d-flex align-items-center" onClick={() => setStopbullyingsResume({type: 'inbox', _id: row._id})}>
                    {new Date(row.date).toLocaleString()}
                </div>,
            selector: (row) => row.date,
            sortable: true,
        }
    ]

    const columnsOut = [
        {
            name: "Asunto",
            cell: row => 
                <div className="d-flex align-items-center" onClick={() => setStopbullyingsResume({type: 'outbox', _id: row._id})}>
                    {row.subject}
                </div>,
            selector: (row) => removeAccents(row.subject),
            sortable: true,
        },
        {
            name: 'Fecha',
            cell: row =>
                <div className="d-flex align-items-center" onClick={() => setStopbullyingsResume({type: 'outbox', _id: row._id})}>
                    {new Date(row.date)?.toTimeString().substring(0, 5)+' ('+row.date?.substr(8,2)+'/'+row.date?.substr(5,2)+'/'+row.date?.substr(0,4)+')'}
                </div>,
            selector: (row) => row.name,
            sortable: true,
        }
    ]

    return (
        <>
            <ToolBar titulo={"No al Bullying"} hitos={[
                { titulo: "Inicio", enlace: "/" },
                { titulo: "No al Bullying", enlace: "#" },
            ]} />
            <div id="kt_content_container" className="d-flex flex-column-fluid align-items-start container-xxl">
                <form autoComplete='off' className="form w-100" noValidate="novalidate" id="kt_sign_in_form" onSubmit={pushStopbullyingHandler}>
                    <div className="content flex-row-fluid" id="kt_content">
                        <div className="card card-flush">
                            <div className="card-header py-10">
                                <div className='row w-100'>
                                    <div className='col-12 col-md-10 text-start mb-10'>
                                        <h2 className="text-primary fs-1 mb-1">Listado de mensajes</h2>
                                        <div className='separator'/>
                                    </div>
                                    <div className='col-12 col-md-2 text-left text-md-end px-0'>
                                        <button type='button' className='btn btn-danger rounded-pill' data-bs-toggle="modal" data-bs-target="#staticBackdrop">
                                            <i className='fas fa-plus me-3'/>
                                            Nuevo reporte
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body pt-0">
                                <div className='row'>
                                    <div className='col-12 col-md-4 border-md-end'>
                                        <div className='d-none d-md-block'>
                                            <div className='d-grid mb-4'>
                                                <button type='button' className={`btn rounded-pill btn-white btn-active ${inbox ? 'selected' : ''}`} onClick={() => setInbox(true)}>Bandeja de entrada</button>
                                            </div>
                                            <div className='d-grid'>
                                                <button type='button' className={`btn rounded-pill btn-white btn-active ${inbox ? '' : 'selected'}`} onClick={() => setInbox(false)}>Bandeja de salida</button>
                                            </div>
                                        </div>
                                        <div className='d-block d-md-none'>
                                            <ul className='nav nav-tabs nav-line-tabs pb-5 mb-10'>
                                                <li className='nav-item'>
                                                    <button type='button' className={`btn rounded-pill btn-white btn-active ${inbox ? 'selected' : ''}`} onClick={() => setInbox(true)}>Bandeja de entrada</button>
                                                </li>
                                                <li className='nav-item'>
                                                    <button type='button' className={`btn rounded-pill btn-white btn-active ${inbox ? '' : 'selected'}`} onClick={() => setInbox(false)}>Bandeja de salida</button>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className='col-12 col-md-8'>
                                        {inbox
                                            ?
                                                <CustomDataTable pagination data={stopbullyingsIn} columns={columnsIn} onRowClicked={(row) => setStopbullyingsResume({type: 'inbox', _id: row._id})}/>
                                            :
                                                <CustomDataTable pagination data={stopbullyingsOut} columns={columnsOut} onRowClicked={(row) => setStopbullyingsResume({type: 'outbox', _id: row._id})}/>
                                        }
                                        {stopbullyingsShow
                                            ?
                                                <>
                                                <hr/>
                                                    <Row>
                                                        <Col className="text-start">
                                                            <b>Administración</b>
                                                        </Col>
                                                        <Col className="text-center"><h3>Asunto:</h3> {stopbullyingsShow.subject}</Col>
                                                        <Col className="text-end">
                                                            <h3>Hora - Fecha:</h3> {new Date(stopbullyingsShow.date)?.toTimeString().substring(0, 5)+'  -  '+stopbullyingsShow.date?.substr(8,2)+'/'+stopbullyingsShow.date?.substr(5,2)+'/'+stopbullyingsShow.date?.substr(0,4)}</Col>   
                                                    </Row>
                                                    {inbox
                                                        ?
                                                            <>
                                                                <div className='row border-top mt-5 pt-5'>
                                                                    <div className='col-12 col-md-6 offset-md-6'>
                                                                        <div className='d-grid'>
                                                                            <button type="submit" id="kt_sign_in_submit" className="btn rounded-pill btn-lg btn-primary">     
                                                                                {sendingStopbullying ? (<LoadingBox variant={"primary"}/>)
                                                                                :
                                                                                (<span className="indicator-label">Responder</span>)}
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className='my-5'>
                                                                    <label className="form-label fs-6 fw-bolder text-dark">Descripción</label>
                                                                    <textarea className="form-control mb-3" rows="5" data-kt-element="input" onChange={(e) => setStopbullying(e.target.value)}></textarea>
                                                                </div>
                                                                <div className='my-5'>
                                                                    <label className="form-label fs-6 fw-bolder text-dark">Adjunta imágenes si fuera necesario</label>
                                                                    <input type="file" className='form-control' onChange={handleFileChange} multiple />
                                                                </div>
                                                                {
                                                                    files && files.length > 0
                                                                    ?
                                                                        <div className='row my-10'>
                                                                            {
                                                                                files.map((file, i) => (
                                                                                    <div className='col-12 col-md-6' key={i}>
                                                                                        <img src={URL.createObjectURL(file)} className='w-100'/>
                                                                                    </div>
                                                                                ))
                                                                            }
                                                                        </div>
                                                                    :
                                                                        <></>
                                                                }
                                                            </>
                                                        :
                                                            <></>
                                                    }
                                                    <Row>
                                                        <Col className="text-start p-4">
                                                            <div dangerouslySetInnerHTML={{__html: lastestStopbullyings}}></div>
                                                        </Col>
                                                    </Row>
                                                </>
                                            :
                                                <></>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>

            <div className="modal fade" id="staticBackdrop" data-bs-backdrop="static" tabIndex="-1" aria-labelledby="staticBackdropLabel">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content p-3">
                        <div className="modal-header border-0 pb-0">
                            <div className="text-start w-100">
                                <div className='d-flex align-items-center mb-1'>
                                    <h2 className="text-primary fs-1 mb-0">Reportar de forma anónima un caso de acoso</h2>
                                </div>
                                <div className='separator'/>
                            </div>
                        </div>
                        <div className="modal-body pt-0">
                            <div className='my-10'>
                                <label className="form-label fs-6 fw-bolder text-dark">Asunto</label>
                                <input className="form-control form-control-lg form-control-solid mb-3 mb-lg-0" id="subject" type="text" value={subjectStopbullying || ''} onChange={ e =>setSubjectStopbullying(e.target.value)}/>
                            </div>
                            <div className='my-10'>
                                <label className="form-label fs-6 fw-bolder text-dark">Descripción</label>
                                <textarea className="form-control mb-3" rows="5" data-kt-element="input" placeholder="Describa lo ocurrido" value={newStopbullying || ''} onChange={(e) => setNewStopbullying(e.target.value)}></textarea>
                            </div>
                            <div className='my-10'>
                                <label className="form-label fs-6 fw-bolder text-dark">Adjunta imágenes si fuera necesario</label>
                                <input type="file" className='form-control' accept="image/*" onChange={handleNewFileChange} multiple />
                            </div>
                            {
                                newfiles && newfiles.length > 0
                                ?
                                    <div className='row my-10'>
                                        {
                                            newfiles.map((file, i) => (
                                                <div className='col-12 col-md-6' key={i}>
                                                    <img src={URL.createObjectURL(file)} className='w-100'/>
                                                </div>
                                            ))
                                        }
                                    </div>
                                :
                                    <></>
                            }
                            <div className='d-flex justify-content-end mt-10 mb-5'>
                                <div className='w-75 row'>
                                    <div className='col-6 d-grid'>
                                        <button type="button" className="btn btn-lg btn-outline-dark border border-dark rounded-pill py-5" data-bs-dismiss="modal" ref={modalCancelButton} onClick={closeModal}>Cancelar</button>
                                    </div>
                                    <div className='col-6 d-grid'>
                                        <button type="button" className="btn btn-lg btn-primary rounded-pill py-5" onClick={() => createStopbullyingHandler()}>Enviar</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
